
import { useState } from 'react';

export default function Footer() {
  const [year] = useState(new Date().getFullYear());

  return (
    <footer className="bg-[#060E1C] relative overflow-hidden">
      {/* Top gold border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FFD700]/70 to-transparent"></div>

      {/* Background glow orbs */}
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#FFD700]/4 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#FFD700]/4 rounded-full blur-3xl pointer-events-none"></div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">

          {/* Column 1 — Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/259e2fbe55ce965c9eea2645e77c4653.png"
              alt="Beyond Electrical Services Logo"
              className="h-12 w-auto mb-5"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              NICEIC Approved electricians serving Watford, Rickmansworth &amp; all surrounding areas. Domestic &amp; commercial electrical specialists.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/Beyondelectricalservices/?locale=en_GB"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/5 border border-white/10 rounded-lg hover:bg-[#FFD700] hover:border-[#FFD700] transition-all duration-300 group cursor-pointer"
              >
                <i className="ri-facebook-fill text-gray-400 group-hover:text-[#0A1628] text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/beyond_electrical/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/5 border border-white/10 rounded-lg hover:bg-[#FFD700] hover:border-[#FFD700] transition-all duration-300 group cursor-pointer"
              >
                <i className="ri-instagram-fill text-gray-400 group-hover:text-[#0A1628] text-lg"></i>
              </a>
            </div>
          </div>

          {/* Column 2 — Quick Links */}
          <div>
            <h4 className="text-white font-bold text-base mb-5 flex items-center gap-2">
              <span className="w-1 h-4 bg-[#FFD700] rounded-full inline-block"></span>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', href: '#home' },
                { label: 'About Us', href: '#about' },
                { label: 'Services', href: '#services' },
                { label: 'Gallery', href: '/gallery' },
                { label: 'Areas Covered', href: '#areas' },
                { label: 'Testimonials', href: '#testimonials' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-[#FFD700] text-sm transition-colors duration-200 flex items-center gap-2 group cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-[#FFD700]/0 group-hover:text-[#FFD700] transition-all duration-200 text-sm"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 — Services */}
          <div>
            <h4 className="text-white font-bold text-base mb-5 flex items-center gap-2">
              <span className="w-1 h-4 bg-[#FFD700] rounded-full inline-block"></span>
              Our Services
            </h4>
            <ul className="space-y-3">
              {[
                'Full &amp; Partial Rewiring',
                'Consumer Unit Upgrades',
                'EV Charger Installation',
                'EICR Testing',
                'Fault Finding',
                'Lighting Installation',
                'Smart Home Systems',
                'Emergency Call-Outs',
              ].map((service) => (
                <li key={service}>
                  <a
                    href="#services"
                    className="text-gray-400 hover:text-[#FFD700] text-sm transition-colors duration-200 flex items-center gap-2 group cursor-pointer"
                    dangerouslySetInnerHTML={{ __html: `<i class="ri-flashlight-line text-[#FFD700]/40 group-hover:text-[#FFD700] text-xs transition-colors duration-200"></i>${service}` }}
                  />
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 — Contact */}
          <div>
            <h4 className="text-white font-bold text-base mb-5 flex items-center gap-2">
              <span className="w-1 h-4 bg-[#FFD700] rounded-full inline-block"></span>
              Get In Touch
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:02031981818" className="flex items-start gap-3 group cursor-pointer">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#FFD700]/10 border border-[#FFD700]/20 rounded-lg group-hover:bg-[#FFD700] transition-all duration-300 shrink-0 mt-0.5">
                    <i className="ri-phone-fill text-[#FFD700] group-hover:text-[#0A1628] text-sm transition-colors duration-300"></i>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs mb-0.5">Office</p>
                    <p className="text-gray-300 group-hover:text-[#FFD700] text-sm font-medium transition-colors duration-200">020 3198 1818</p>
                  </div>
                </a>
              </li>
              <li>
                <a href="tel:+447989675952" className="flex items-start gap-3 group cursor-pointer">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#FFD700]/10 border border-[#FFD700]/20 rounded-lg group-hover:bg-[#FFD700] transition-all duration-300 shrink-0 mt-0.5">
                    <i className="ri-smartphone-line text-[#FFD700] group-hover:text-[#0A1628] text-sm transition-colors duration-300"></i>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs mb-0.5">Mobile</p>
                    <p className="text-gray-300 group-hover:text-[#FFD700] text-sm font-medium transition-colors duration-200">+44 7989 675952</p>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:admin@beyondelectrical.co.uk" className="flex items-start gap-3 group cursor-pointer">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#FFD700]/10 border border-[#FFD700]/20 rounded-lg group-hover:bg-[#FFD700] transition-all duration-300 shrink-0 mt-0.5">
                    <i className="ri-mail-fill text-[#FFD700] group-hover:text-[#0A1628] text-sm transition-colors duration-300"></i>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs mb-0.5">Email</p>
                    <p className="text-gray-300 group-hover:text-[#FFD700] text-sm font-medium transition-colors duration-200 break-all">admin@beyondelectrical.co.uk</p>
                  </div>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#FFD700]/10 border border-[#FFD700]/20 rounded-lg shrink-0 mt-0.5">
                    <i className="ri-time-fill text-[#FFD700] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs mb-0.5">Hours</p>
                    <p className="text-gray-300 text-sm">Mon–Fri: 8am–6pm</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Certifications strip */}
        <div className="border-t border-white/5 pt-8 pb-6">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {['NICEIC Approved', 'City &amp; Guilds', 'IPAF Certified', 'Checkatrade', 'BS7671 Compliant'].map((cert) => (
              <span
                key={cert}
                className="inline-flex items-center gap-1.5 bg-[#FFD700]/10 border border-[#FFD700]/20 text-[#FFD700] text-xs font-semibold px-3 py-1.5 rounded-full"
                dangerouslySetInnerHTML={{ __html: `<i class="ri-shield-check-fill text-xs"></i>${cert}` }}
              />
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs text-center sm:text-left">
            © {year} Beyond Electrical Services Ltd. All Rights Reserved.
          </p>
          <p className="text-gray-600 text-xs text-center sm:text-right">
            Company No: 11479093 &nbsp;|&nbsp; NICEIC Approved Contractor &nbsp;|&nbsp;
            <a href="http://www.beyondelectrical.co.uk/" target="_blank" rel="noopener noreferrer" className="hover:text-[#FFD700] transition-colors duration-200">beyondelectrical.co.uk</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
